import React from "react";
import {
  Dimensions,
  View,
  StyleSheet,
  useWindowDimensions,
} from "react-native";
import ChipCard from "./ChipCard";

import {
  chipImgOne,
  chipImgThree,
  chipImgTwo,
  ChipsBackgrOne,
  ChipsBackgrOneLand,
  ChipsBackgrTwo,
  ChipsBackgrTwoLand,
  goldChipIcon,
} from "../../../../assets";

import { useDevice } from "../../../../utils/hooks/useDevice";
import { Package } from "../../../../store/types";
import ChipCardDesktop from "./ChipCardDesktop";
import WatchAdButton from "../../common/WatchAdButton";

interface ChipScreenProps {
  chipPackages: Package[];
  onPayment: (pkg: Package) => void;
}

const screenWidth = Dimensions.get("window").width;

const ChipScreen: React.FC<ChipScreenProps> = ({ chipPackages, onPayment }) => {
  console.log(chipPackages);
  const { isPortrait } = useDevice();
  const { width } = useWindowDimensions();

  const shouldUseMobileLayout = isPortrait || width < 1000;

  if (shouldUseMobileLayout) {
    return (
      <>
        <View
          style={{
            width: "100%",
            maxWidth: 900,
            alignSelf: "center",
            maxHeight: "100%",
            flex: 1,
            minHeight: 0,
            rowGap: 10,
            justifyContent: "center",
            alignContent: "center",
            // marginLeft: 40,
            // margin: "auto",
          }}
        >
          {/* <ScrollView
            style={{ flex: 1 }}
            contentContainerStyle={{ padding: 10 }}
            showsVerticalScrollIndicator={true}
            nestedScrollEnabled={true}
            keyboardShouldPersistTaps="handled"
          > */}
          {chipPackages.map((item, index) => {
            return (
              <ChipCard
                key={item.id}
                vipIcon={chipImgOne}
                borderColor="#C0C0C0"
                textColor="#FFD700"
                vipLabel={goldChipIcon}
                chipBackground={ChipsBackgrOneLand}
                amount={Number(item.chipAmount) || 0}
                price={Number(item.price) || 0}
                pkg={item}
                onPayment={onPayment}
              />
            );
          })}
          {/* Watch Ad button — mobile only */}
          <WatchAdButton compact />
          {/* </ScrollView> */}
        </View>
      </>
    );
  }

  return (
    <View style={styles.desktopContainer}>
      <View style={styles.gridContainer}>
        <View style={styles.gridWrapper}>
          <View style={styles.packagesGrid}>
            {chipPackages.map((item, index) => {
              return (
                <View key={item.id} style={styles.packageWrapper}>
                  <ChipCardDesktop
                    vipIcon={chipImgOne}
                    borderColor="#C0C0C0"
                    textColor="#FFD700"
                    vipLabel={goldChipIcon}
                    chipBackground={ChipsBackgrOne}
                    amount={Number(item.chipAmount) || 0}
                    price={Number(item.price) || 0}
                    pkg={item}
                    onPayment={onPayment}
                  />
                </View>
              );
            })}
          </View>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  scrollContainer: {
    paddingHorizontal: 1,
    paddingRight: screenWidth / 3,
  },
  halfCardWrapper: {},

  desktopContainer: {
    width: "100%",
  },

  gridContainer: {
    padding: 15,
    paddingBottom: 30,
    alignItems: "center",
  },

  gridWrapper: {
    maxWidth: 700,
    width: "100%",
  },

  packagesGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    columnGap: 10,
    rowGap: 10,
  },

  packageWrapper: {
    width: "32%",
    marginBottom: 0,
  },
});

export default ChipScreen;
